module.exports = __webpack_public_path__ + "img/icon-question-duplicate.092b613d.svg";